var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "va-row dealDetails", attrs: { id: "dealDetails" } },
    [
      _c("div", { staticClass: "va-row" }, [
        _c(
          "div",
          { staticClass: "flex xs12 md12" },
          [
            _c("vuestic-widget", { staticStyle: { "margin-bottom": "0" } }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c(
                  "table",
                  { staticClass: "table table-striped first-td-padding" },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("td", {}, [_vm._v(_vm._s(_vm.tableData["0"]["2"]))]),
                        _c("td", {}, [
                          _vm._v(_vm._s(_vm.tableData["0"]["16"])),
                        ]),
                        _c("td", {}, [
                          _vm._v(_vm._s(_vm.tableData["0"]["20"])),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.tableData.slice(1), function (item) {
                        return _c("tr", [
                          item && _vm.itemHK(item, "2")
                            ? _c("td", {}, [
                                _vm._v(_vm._s(item["2"] ? item["2"] : "")),
                              ])
                            : _vm._e(),
                          item && _vm.itemHK(item, "3")
                            ? _c(
                                "td",
                                {
                                  staticStyle: {
                                    "padding-left": "40px !important",
                                  },
                                },
                                [
                                  _vm._v(
                                    "  " + _vm._s(item["3"] ? item["3"] : "")
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("td", {}, [
                            _vm._v(_vm._s(item["16"] ? item["16"] : "")),
                          ]),
                          _c("td", {}, [
                            _vm._v(_vm._s(item["20"] ? item["20"] : "")),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }